import { useEffect, useState } from 'react';

import Button from '@components/button/Button';
import { SourceSelectItem } from '@features/lead-management/hooks/useLeadSources';

import {
  INPUT_BASE_CLASSNAME,
  INPUT_FOCUS_CLASSNAME
} from '../../constants/common';

interface EditSourceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (source: SourceSelectItem) => void;
  editingItem: SourceSelectItem | null;
  labelName?: string;
}

const EditSourceModal = ({
  isOpen,
  onClose,
  onSave,
  editingItem: source,
  labelName = 'Lead Source'
}: EditSourceModalProps) => {
  const [sourceName, setSourceName] = useState(source?.name || '');

  useEffect(() => {
    if (source) {
      setSourceName(source.name || '');
    }
  }, [source]);

  const handleSave = () => {
    if (source && sourceName.trim()) {
      onSave({ ...source, name: sourceName.trim() });
      onClose();
    }
  };

  const handleCancel = () => {
    setSourceName(source?.name || '');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
      data-edit-modal
    >
      <div className="w-[400px] max-w-[90vw] rounded-xl bg-theme p-6 shadow-lg">
        <div className="flex flex-col gap-4">
          <span className="text-base font-semibold text-content1">
            {labelName}
          </span>
          <input
            type="text"
            value={sourceName}
            onChange={(e) => setSourceName(e.target.value)}
            placeholder="Enter source name..."
            className={`w-full rounded-lg px-4 py-3 text-sm text-content1 placeholder:text-grey40 ${INPUT_BASE_CLASSNAME} ${INPUT_FOCUS_CLASSNAME}`}
          />
          <div className="flex items-center gap-3">
            <Button
              variant="tertiary"
              label="Cancel"
              handleClick={handleCancel}
              className="flex-1"
            />
            <Button
              variant="primary"
              label="Save"
              handleClick={handleSave}
              disabled={!sourceName.trim()}
              className="flex-1"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSourceModal;
